require('./bootstrap');
require('../../node_modules/overlayscrollbars/js/jquery.overlayScrollbars')
require('./adminlte/AdminLTE');

import barba from '@barba/core';
import barbaCss from '@barba/css';



// DATATABLES IN ADMIN PANEL
require('datatables.net/js/jquery.dataTables')
require('datatables.net-responsive-bs4/js/responsive.bootstrap4')
import 'datatables.net-bs4'
//require('../datatables/dataTables.bootstrap4')

// require( 'datatables.net-buttons/js/');

require( 'datatables.net-buttons/js/dataTables.buttons');
require( 'datatables.net-buttons-bs4/js/buttons.bootstrap4');
// require( 'datatables.net-buttons/js/buttons.html5.js' );
require( 'datatables.net-buttons/js/buttons.print.js' );
// require( 'datatables.net-buttons/js/buttons.colVis');



// Call the dataTables jQuery plugin
$(document).ready(function() {
  let table = $('#dataTable').DataTable({
    // lengthChange: false, /* Hide result entries change selector */
    buttons: [ 
        {
            text : '<i class="fas fa-print"></i> <span class="d-inline-block"> Imprimir</span>',
            extend : 'print',
            className : 'btn btn-danger btn-sm shadow-sm'
        }, 
        // 'excel', 
        // 'pdf', 
        // 'colvis'
    ]
  });

  table.buttons().container()
  .removeClass('btn-group')
  .addClass('d-flex justify-content-end align-items-center')
  .appendTo( '#dataTable_buttons_wrapper' );
//   .appendTo( '#dataTable_wrapper .row:eq(2) .col-sm-12:eq(0)' );
});

// // tell Barba to use the css plugin
barba.use(barbaCss);

function scrollToTop(elemet) {
    window.scrollTo({ top: 0, behavior: 'smooth' });

}


//MAIN NAVIGATION MENU
function OpenMenu() {
    let sidebar = document.querySelector('.sidebar-navigation');

    if (sidebar) {
        let menuBtn = document.querySelector('.menu-btn'),
            buttons = sidebar.querySelectorAll('a.nav-link'),
            menuIcon = menuBtn.querySelector('i');

        function toggleSideMenu(){
            sidebar.classList.toggle('active')  
            
            menuIcon.classList.toggle('fa-bars');
            menuIcon.classList.toggle('fa-times');
        
        }
        
        buttons.forEach(button => {
            button.addEventListener('click',toggleSideMenu);
        })
            
        menuBtn.addEventListener('click', toggleSideMenu);
    }

}

function setNavbarHeight() {
    // Get the DOM Node if you pass in a string
    let menuBtn = document.querySelector('.main-navigation');
    if(menuBtn) {
        // debugger
        let styles = window.getComputedStyle(menuBtn),
            margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']),
            result = Math.ceil(menuBtn.offsetHeight + margin),
            hero = document.querySelector('#hero');
        
            hero.style.setProperty('--nav-height', result + "px");
    }
}


//DEV HELPERS
function debounce(func){
    var timer;
    return function(event){
        if(timer) clearTimeout(timer);
        timer = setTimeout(func,100,event);
    };
}
function scrollProducts()  {
    let productContainers = document.querySelectorAll('.product-container');

    productContainers.forEach(product => {
        if(!product.classList.contains('.toggled')){
            product.addEventListener('click', say_my_name('product'))
        }
    });
}
function say_my_name(name) {
    if(name) {
        console.log(name) ;    
    } else {
        console.log('My name')
    }
}



function openCurtain() {
    let body = document.querySelector('body');

    if(body.classList.contains('not-loaded')) {
        body.classList.remove('not-loaded')
    }
}

function setupProductsJs() {
    let productsSection = document.getElementById("products");
    let products = null;
    if(productsSection) {
        products = productsSection.querySelectorAll(".product-container");
    }
    if(products) {
        products.forEach((product) => {
            product.addEventListener("click", function(){
                toggleStateActive(product)
            });
        });
    }
    
    
    function toggleStateActive(product) {
        // setRemoveButton(product);
        products.forEach(prod => {
            if(prod !== product){
                removeStateActive(prod);
            } else {
                if(!product.classList.contains('active')) {
                    removeStateActive(prod);
                    resizeSiblingProducts(product);
                    product.classList.add('active');
                    // setTimeout(() => {
                    //     scrollInto(product);
                    // },760)
                } else {
                    removeStateActive(prod);
                }
            }
        });
    
    }
    
    
    function removeStateActive(product) {
        product.classList.remove('active')
        product.classList.remove("full-grid");
        product.classList.remove("half-grid");
        product.classList.remove("fade-out-product");
    }
    
    
    
    function resizeSiblingProducts(product) {
        let indexCounter = parseInt(product.dataset.productCounter);
        let indexFlag = parseInt(product.dataset.productFlag);
        if(!product.classList.contains("active")){
    
            products.forEach(prods => {
                let prodsCounter = parseInt(prods.dataset.productCounter);
                switch (indexFlag) {
                    
                    case 1:
                        
                        if(prodsCounter == (indexCounter+1)){
                            prods.classList.add("fade-out-product");
                            setTimeout(() => {
                                prods.classList.remove("fade-out-product");
                            }, 1000);
                        }
                        if(prodsCounter == (indexCounter+2)){
                            prods.classList.add("fade-out-product");
                            setTimeout(() => {
                                prods.classList.remove("fade-out-product");
                            }, 1000);
                        }
                    break;
                    
                    case 2:
                        if(prodsCounter == (indexCounter-1)){
                            prods.classList.add("full-grid");
                        }
                        if(prodsCounter == (indexCounter+1)){
                         
                            prods.classList.add("fade-out-product");
    
                            setTimeout(() => {
                                prods.classList.remove("fade-out-product");
                            }, 1000);
                        }
                    break;
                    
                    case 3:
                        if(prodsCounter == (indexCounter-2)){
                            prods.classList.add("half-grid");
                        }
                        if(prodsCounter == (indexCounter-1)){
                            prods.classList.add("half-grid");
                        }
                        if(prodsCounter == (indexCounter+1)){
                            prods.classList.add("fade-out-product");
                            setTimeout(() => {
                                prods.classList.remove("fade-out-product");
                            }, 1000);
                        }
                    break;
            
                    default:
                    
                    break;
                }
            })
        }
    }    
}

function scrollInto(target) {
    let offsetTop = target.offsetTop;
    scroll({
        top: offsetTop,
        behavior: "smooth"
    });

    //    window.scrollTo(0,offsetTop);
};

//BARBA JS
barba.init({
    transitions: [
        {
            name: 'home',
            once() {},
            leave() {},
            enter() {},

            beforeEnter(data) {
                // do something before entering the `contact` namespace
                // debugger
                // console.log('enter home');
                scrollToTop();
            },

            beforeOnce(data) {
                // do something before entering the `contact` namespace
                // debugger
                // console.log('first enter on load home');
                scrollToTop();
            },

            afterEnter() {
                // setupProductsJs();
            }
        },
        {
            name: 'product',
            from: {
                namespace: ['product-marmoles'],
                
            },
            to: {
                namespace: ['product-marmoles']
            },
            // sync:true,
            beforeEnter(data) {
                // do something before entering the `contact` namespace
                // debugger
                // console.log('enter products marmoles');
                scrollToTop();
              },
            beforeLeave(data) {
                // do something before entering the `contact` namespace
                // debugger
                // console.log('leave products  marmoles');
            },
            afterEnter() {
                setupProductsJs();
            },
            leave() {},
            enter() {}
        },
        
        // PRODUCT SHOW INSIDE A CATEGORY

        {
            name: 'product-show',
            from: {
                namespace: ['product-marmoles','product-cuarzos','product-granitos'],
                
            },
            to: {
                namespace: ['product-marmoles-show', 'product-cuarzos-show', 'product-granitos-show'],
            },
            // sync:true,
            beforeEnter(data) {
                // do something before entering the `contact` namespace
                // debugger
                // console.log('enter products marmoles');
                // scrollToTop();
              },
            beforeLeave(data) {
                // do something before leaving the `show` namespace
                // debugger
                // console.log('leave products  marmoles');
            },
            afterEnter() {
                // setupProductsJs();
            },
            leave() {},
            enter() {}
        },

        // INDIVIDUAL PRODUCT SHOW CLOSE INSIDE SAME CATEGORY

        {
            name: 'product-show-close',
            from: {
                namespace: ['product-marmoles-show'],
                
            },
            to: {
                namespace: ['product-marmoles']
            },
            // sync:true,
            beforeEnter(data) {
                // do something before entering the `contact` namespace
                // debugger
                // console.log('enter products marmoles');
                // scrollToTop();
              },
            beforeLeave(data) {
                // do something before leaving the `show` namespace
                // debugger
                // console.log('leave products  marmoles');
            },
            afterEnter() {
                // setupProductsJs();
                // debugger
            },
            afterLeave() {
                // setupProductsJs();
                // debugger
            },
            leave() {},
            enter() {}
        },

        {
            name: 'product-show-close',
            from: {
                namespace: ['product-cuarzos-show'],
                
            },
            to: {
                namespace: ['product-cuarzos']
            },
            // sync:true,
            beforeEnter(data) {
                // do something before entering the `contact` namespace
                // debugger
                // console.log('enter products marmoles');
                // scrollToTop();
              },
            beforeLeave(data) {
                // do something before leaving the `show` namespace
                // debugger
                // console.log('leave products  marmoles');
            },
            afterEnter() {
                // setupProductsJs();
                // debugger
            },
            afterLeave() {
                // setupProductsJs();
                // debugger
            },
            leave() {},
            enter() {}
        },

        {
            name: 'product-show-close',
            from: {
                namespace: ['product-granitos-show'],
                
            },
            to: {
                namespace: ['product-granitos']
            },
            // sync:true,
            beforeEnter(data) {
                // do something before entering the `contact` namespace
                // debugger
                // console.log('enter products marmoles');
                // scrollToTop();
              },
            beforeLeave(data) {
                // do something before leaving the `show` namespace
                // debugger
                // console.log('leave products  marmoles');
            },
            afterEnter() {
                // setupProductsJs();
                // debugger
            },
            afterLeave() {
                // setupProductsJs();
                // debugger
            },
            leave() {},
            enter() {}
        },

        // INDIVIDUAL PRODUCT SHOW SWITCH INSIDE SAME CATEGORY

        {
            name: 'product-show-between',
            from: {
                namespace: ['product-marmoles-show', 'product-cuarzos-show', 'product-granitos-show'],
                
            },
            to: {
                namespace: ['product-marmoles-show', 'product-cuarzos-show', 'product-granitos-show'],
            },
            // sync:true,
            beforeLeave(data) {
                // do something before leaving the `show` namespace
                // debugger
                // console.log('leave products  marmoles');
            },
            afterEnter() {
                // setupProductsJs();
                let product = document.querySelector(".product-container.active");
                if(product){
                    scrollInto(product);
                }
            },
            leave() {},
            enter() {}
        },
        
        // PRODUCT CATEGORY SELECTION

        {
            name: 'category-product',
            from: {
                namespace: ['category-marmoles'],
                
            },
            to: {
                namespace: ['product-marmoles']
            },
            // sync:true,
            beforeEnter(data) {
                // do something before entering the `contact` namespace
                // debugger
                // console.log('enter products');
                scrollToTop();
              },
            beforeLeave(data) {
                // do something before entering the `contact` namespace
                // debugger
                // console.log('leave category');
            },
            afterEnter() {
                // setupProductsJs();
            },
            leave() {},
            enter() {}
        },
    ]
});


//RUNTIME
window.onload = function() {
    setNavbarHeight();
    OpenMenu();
    
    // scrollProducts();
    //EVENT LISTENERS
    // openCurtain();

    window.addEventListener("resize",debounce(setNavbarHeight));
    // setupProductsJs();
}


